import type {BetterAuthClientPlugin} from "better-auth/client";

import type {kepAuthPlugin} from "./kep-auth-plugin.ts";

export const kepAuthClient = () => ({
    id: "kep-auth",
    $InferServerPlugin: {} as ReturnType<typeof kepAuthPlugin>,
    pathMethods: {
        "/kep/challenge": "POST",
        "/kep/verify": "POST",
    },
    atomListeners: [{
        matcher: (path: string) => path === "/kep/verify",
        signal: "$sessionSignal",
    }],
}) satisfies BetterAuthClientPlugin;
